export const loadLocales = (data) => data
export const loadLabels = (data) => data
